import { ENV_VARS } from 'ENV_CONFIG';

export const staticContent = {
  // --------------------
  // header
  // --------------------

  browse_url: 'https://www.johnlewis.com',
  logo_alt: 'John Lewis',
  logo_alt_b: 'John Lewis & Partners',
  menu_sign_out: 'Sign out',
  menu_basket: 'Basket',
  basket_url: `${ENV_VARS.REACT_APP_BROWSE_HOST}/basket`,
  skip_to_main_content: 'Skip to main content',
  skip_to_footer: 'Skip to footer',
  breadcrumb_home: 'Service details',
  // --------------------
  // homepage
  // --------------------
  securityCopy: 'johnlewis.com is secure',

  navBack: 'Our services',
  navOrders: 'Orders',
  navAccountOverview: 'Account overview',
  navOnlineOrders: 'Online orders',
  navMyDetails: 'My details',
  navMyJL: 'my John Lewis',
  navWishlist: 'Wish List',
  navMarketingPreferences: 'Marketing preferences',
  navReviews: 'Reviews and comments',
  navReceipts: 'In-store receipts',
  navAppointments: 'Appointments',
  navHelp: 'Help',
  navContactInformation: 'Contact information',
  navAddressBook: 'Address book',
  navPaymentDetails: 'Payment details',
  navEditPassword: 'Edit password',
  navBackToPrevious: 'Back to previous page',
  navBackToTrackOrder: 'Back',

  // desktop links
  desktop_account_url: 'https://www.johnlewis.com/myaccount',
  desktop_wish_list_url:
    'https://www.johnlewis.com/handover/sign-in?backPage=/&callingPage=/myaccount/wish-list&s_1jlredir=1',
  link_to_app_store:
    'https://itunes.apple.com/gb/app/john-lewis-shopping-made-easy/id486502369?mt=8',
  link_to_play_store:
    'https://play.google.com/store/apps/details?id=com.johnlewis.android&hl=en_GB',

  // --------------------
  // page titles
  // --------------------
  homepage_page_title: 'My Account | John Lewis',
  track_your_order_page_title: 'Track your orde | My Accountr | John Lewis',
  register_title: 'Create an account | John Lewis',
  address_book_title: 'Address book | My Account | John Lewis',
  address_book_title_add: 'Add Address | Address book | My Account | John Lewis',
  address_book_title_edit: 'Edit Address | Address book | My Account | John Lewis',
  // --------------------
  // errors
  // --------------------
  generic_error_page_title: 'Page not found | John Lewis',
  generic_error_title: "Sorry, we couldn't find this page",
  generic_error_message: 'The link may be out of date, or you may have mistyped the address (URL)',
  generic_error_cta: 'Go to homepage',
  connectivity_error_title: "Sorry, we can't display the page you requested",
  connectivity_error_message:
    "We've notified our website team of this technical issue. Please try again later, or try our homepage.",
  order_connectivity_error_title: 'Online orders',
  order_connectivity_error_message:
    'Sorry we are unable to show your orders right now due to a technical error. Please try again later.',
  store_receipt_connectivity_error_title: 'In-store receipts',
  store_receipt_connectivity_error_message:
    'Sorry we are unable to show your receipts right now due to a technical error. Please try again later.',
  unexpected_server_error_title: "Sorry, we can't display the page you requested",
  unexpected_server_error_message:
    "We've notified our website team of this technical issue. Please try again later, or try our homepage.",
  unknown_technical_error_title: "Sorry, we can't display the page you requested",
  unknown_technical_error_message:
    "We've notified our website team of this technical issue. Please try again later, or try our homepage.",
  order_not_found_page_title: 'Order not found | My Account | John Lewis',
  order_not_found_title: "Sorry, we couldn't find that order",
  order_not_found_message:
    'The link may be out of date, or you may have mistyped the address (URL)',
  unknownErrorTitle: "Sorry, we've had a technical problem.",
  unknownErrorBody: 'Please try again.',
  registrationEmailAlreadyExistsMessage: 'This email address is already linked to an account',
  registrationEmailAlreadyExistsBody: 'Please enter a new email address or sign in',
  loginInvalidCredentialsMessage: "We didn't recognise your details",
  loginInvalidCredentialsBody: 'Please check your email and password.',
  loginLockedAccountMessage: 'Account locked',
  loginLockedAccountBody:
    'We\'ve locked your account as a security precaution, to re-activate it please <a href="/redirect/onejl/forgotten-password">create a new password</a>',
  loginDormantAccountMessage: 'Dormant account',
  loginDormantAccountBody:
    'Because your account hasn\'t been used in a while we need you to <a href="/redirect/onejl/forgotten-password">reset your password</a>',
  loginGhostAccountMessage: 'You have not yet created a password for this account',
  loginGhostAccountBody:
    'Please <a href="/redirect/onejl/forgotten-password">create a password</a> to sign in',
  trackOrderNotFoundMessage: "We can't match your record",
  trackOrderNotFoundBody: 'Please check your order number and postcode',
  myJLCancelFailedMessage: 'Sorry, there was a problem cancelling your membership',
  myJLCancelFailedBody: 'Please try again',
  myJLDetailsUnavailableMessage: 'Sorry there was a problem obtaining your details',
  myJLDetailsUnavailableBody: 'Please try again',
  myJLSystemUnavailableMessage: 'Sorry, there was a problem setting up your my JL account',
  myJLSystemUnavailableBody: 'Please try again',
  partnerCardAssociatedMessage: 'This number is already linked to an account',
  partnerCardAssociatedBody:
    'For information please <a href="https://partnerintranet.co.uk/content/itr/home-services/policies-and-procedures/personnel/working-for-the-partnership/partnership-discount-standard/partnership-discount-operating-procedures.html">click here for the Partnership Discount Operating Procedures</a>.',

  // --------------------
  // my john lewis constants
  // --------------------
  myJLPageHeading: 'my John Lewis',
  myJLInfoHeading: 'Your membership card',
  myJLBenefitsHeading: "By scanning your card you'll get",
  myJLCancelHeading: 'Want to leave?',
  // --------------------
  // address book constants
  // --------------------
  address_book_heading: 'Address book',
  address_book_contact_address: 'Contact address',
  address_book_payment_address: 'Payment address',
  address_book_alternative_phone_number: 'Alternative',
  address_book_text_add: 'Add new address',
  address_book_heading_add: 'Add address',
  address_book_heading_edit: 'Edit address',
  address_book_edit_text: 'Edit',
  address_book_payment_message_edit:
    'This address is linked to a payment card. Any changes will also update the payment card details.',
  address_book_delete_text: 'Delete',
  address_book_icon: 'Plus',
  address_book_payment_edit_notification:
    'This address is linked to a payment card. Any changes will also update the payment card details.',
  address_book_notification_add: 'Your address has been successfully added.',
  address_book_notification_edit: 'Your address has been successfully updated.',
  address_book_delete_notification: 'Your address has been successfully deleted.',
  address_book_connectivity_error_title: "Sorry, we're unable to show your address book right now",
  address_book_contact_delete_message:
    "You can't delete your contact address as we need this to send you documents such as guarantees in the post.",
  address_book_connectivity_error_message: 'Please try again later.',
  address_book_address_error_title_add: 'Add address',
  address_book_address_error_title_edit: 'Edit address',
  address_book_address_error_message_add:
    'Sorry, we are unable to add an address to your address book right now due to a technical error. Please try again later.',
  address_book_address_error_message_edit:
    'Sorry, we are unable to update an address in your address book right now due to a technical error. Please try again later.',
  address_book_payment_delete_modal_button: 'Back',
  address_book_payment_delete_modal_title: 'Address linked to payment card',
  address_book_payment_delete_modal_text:
    "This address is linked to one or more payment cards. If you'd like to delete it please go to payment cards.",
  address_book_contact_delete_modal_button: 'Back',
  address_book_contact_delete_modal_title: 'Contact address',
  address_book_contact_delete_modal_text:
    "You can't delete your contact address as we send you things like guarantees in the post.",
  address_book_form_alt_phone_number_label: 'Alternative phone number',
  address_book_form_phone_number_label: 'Phone number',

  //
  // my details constants
  //
  my_details_contact_details_title: 'Contact details',
  my_details_address_book_title: 'Address book',
  my_details_change_password_title: 'Change password',
  my_details_payment_cards_title: 'Payment cards',
  my_details_payment_cards_info:
    '* If you would like to update your payment cards please do so at the point of purchase.',
  //
  // wish list constants
  //
  wish_list_heading: 'Wish List',
  wish_list_max_lists_message_reached: 'You have reached the maximum of 5 wish lists',
  wish_list_max_lists_message: 'You can create up to 5 wish lists',
  wish_list_create_modal_heading: 'Create a Wish List',
  wish_list_row_label_edit: 'Edit',
  wish_list_email_when_stocked: 'Email when in stock',
  wish_list_email_modal:
    "Enter your email and we'll contact you when the below product is available.",
  wish_list_email_modal_error: 'Sorry, there seems to be a problem. Please try again later',
  wish_list_email_confirmation_heading: "We've just sent you a confirmation email",
  wish_list_email_confirmation_text: "We'll contact you again when the product becomes available.",
  // --------------------
  // order status constants
  // --------------------
  orderMissing: "Couldn't find that order",
  orderLoading: 'Finding your order',
  orderIdLabel: 'Order number:',
  order_progress_label: 'Order progress',
  order_progress_timestamp_empty: 'Future status, information coming soon',
  // delivery information
  scheduled_delivery_title: 'Scheduled delivery date',
  scheduled_delivery_message: 'Coming soon',
  scheduled_delivered_title: 'Delivered on',
  scheduled_failed_delivery_title: 'Attempted on',
  // --------------------
  // order statuses
  // --------------------
  order_type_unknown_title: 'Order processing',
  order_type_unknown_hero: "We're processing your order, please check back for an update",
  order_type_unknown_message: 'Your tracking information will be available soon.',
  // click and collect
  order_confirmed_title: 'Order received',
  order_confirmed_hero:
    "We're processing your order, and we will send you an email and text when it's ready to collect.",
  dispatched_title: 'Order dispatched',
  dispatched_hero:
    "Your order's on its way to your chosen location. We'll be in touch again by email and text when it's ready to collect.",
  delayed_title: 'Order currently delayed',
  delayed_hero:
    "We're sorry that your order has been delayed. It should arrive today or tomorrow, but we'll let you know via email and text as soon as it does.",
  ready_for_collection_title: 'Order ready for collection',
  ready_for_collection_hero:
    "We're pleased to let you know that your order is ready for collection – We require you to collect this within 7 days, otherwise it will be returned to our warehouse and we will refund you automatically.",
  delayed_in_store_title: 'Order currently delayed',
  delayed_in_store_hero:
    "We're sorry that your order has been delayed. We'll be in touch again with an update in the next few hours.",
  collected_title: 'Order collected',
  collected_hero:
    "We've been notified that your order has been collected.<br/> Thank you for shopping at John Lewis.",
  partially_collected_title: 'Order partially collected',
  partially_collected_hero:
    "We've been notified that part of your order has been collected. Thank you for shopping at John Lewis.",
  uncollected_title: 'Order collection period expired, processing a return',
  uncollected_hero:
    "Your order has been at your chosen location for 7 days, but remained uncollected so we're returning it to our warehouse and will process a refund.",
  refund_processing_title: 'Order returned, processing a refund',
  refund_processing_hero:
    "We've received your order in our warehouse and will process a full refund in the next few days.",
  refunded_title: 'Refund processed',
  refunded_hero: "We've now processed the refund on this order. Thank you for shopping with us.",
  returned_title: 'Order returned',
  returned_hero: "We've received your order in our warehouse.",
  cancelled_title: 'Order cancelled',
  cancelled_hero:
    "We've been notified that your order has been cancelled and that you've received assistance to resolve the matter.",
  cancelled_help_title: 'Further queries?',
  cancelled_help_message:
    '<p>We\'ve now closed your order so there will be no further updates here, but if you have any further queries, please contact our <a href="https://www.johnlewis.com/customer-services">Customer Services</a>.</p><p>Thank you for shopping at John Lewis.</p>',
  completed_hero:
    "We've been notified that your order has not been collected, but you've received assistance to resolve the matter.",
  completed_title: 'Order closed',
  completed_help_title: 'Further queries?',
  completed_help_message:
    '<p>This order is now closed so no further tracking information will be updated here.</p> <p>If you have any further queries, please contact our <a href="https://www.johnlewis.com/customer-services">Customer Services</a>.</p><p>Thank you for shopping at John Lewis.</p>',
  // green van fleet
  order_confirmed_gvf_title: 'Order received',
  order_confirmed_gvf_hero:
    "Your order is being processed – we'll send a text to remind you when your delivery slot is scheduled.",
  order_confirmed_gvf_unscheduled_title: 'Order received',
  order_confirmed_gvf_unscheduled_hero:
    "We'll be scheduling your delivery shortly, and will send you a text or an automated voice message to confirm.",
  in_depot_title: 'Arrived at depot',
  in_depot_hero: 'Your order has arrived at our depot, and will be loaded on to our van soon.',
  loaded_on_van_title: 'Ready for dispatch',
  loaded_on_van_hero:
    'Your order has been loaded on to our van, ready to be delivered to your chosen address.',
  out_for_delivery_title: 'Out for delivery',
  out_for_delivery_hero:
    'Your delivery is on its way and will arrive within the scheduled delivery time.',
  delivered_title: 'Delivered',
  delivered_hero:
    "We've been notified that your order has been delivered successfully. Thank you for shopping at John Lewis.",
  failed_delivery_title: 'Undelivered',
  failed_delivery_hero:
    "We've been notified that your order has not been delivered. If we haven't already been in touch to resolve this, we'll be contacting you shortly.",
  delayed_gvf_title: 'Currently delayed',
  delayed_gvf_hero:
    "We're sorry that your order has been delayed. If we haven't already been in touch, we'll be contacting you shortly.",
  partial_delivery_title: 'Partially delivered',
  partial_delivery_hero:
    "We've been notified that part of your order has been delivered. If we haven't already been in touch, we'll be contacting you shortly.",
  alt_carrier_title: 'Collected by carrier',
  alt_carrier_hero:
    "Your order has been collected by our nominated carrier. If we haven't already been in touch we'll be contacting you shortly.",
  // --------------------
  // fulfilment types
  // --------------------
  delivery_details_title: 'Delivery details',
  delivery_option_title: 'Delivery option',
  chose_store_title: 'Collect from',
  delivery_postcode_title: 'Delivery to',
  collection_title: 'Collect from',
  delivery_method_title: 'Delivery method',
  // collect+
  fulfilment_collect_plus_title: 'Collect+',
  fulfilment_collect_plus_description:
    "Collect+ will send you an email and a text message when it's ready to collect.",
  fulfilment_collect_plus_availability:
    'Your order will be ready to collect by the end of <strong>${date}</strong> and will be available for <strong>10 days</strong>.',
  // click and collect
  fulfilment_click_and_collect_title: 'Click and Collect',
  fulfilment_click_and_collect_availability:
    'Your order will be ready to collect at <strong>2pm</strong> on <strong>${date}</strong>.',
  fulfilment_click_and_collect_description:
    "We'll hold your order in store for <strong>7 days</strong>, after which we'll return the order to the warehouse and refund your account.",
  fulfilment_click_and_collect_not_available: 'Your order is no longer available to collect',
  // green van fleet
  fulfilment_green_van_fleet_title: 'Standard Delivery',
  fulfilment_green_van_fleet_description: 'Delivered to UK address',
  fulfilment_green_van_fleet_not_available: 'Your order is no longer available for delivery',
  // alternative carrier
  fulfilment_alt_carrier_title: 'Standard Delivery',
  fulfilment_alt_carrier_description: 'Delivery is with our nominated carrier',
  fulfilment_alt_carrier_not_available: 'Your order is no longer available for delivery',
  // standard delivery
  fulfilment_standard_delivery_title: 'Standard delivery in 5 working days',
  fulfilment_standard_delivery_description:
    'Delivery <strong>within 5 working days</strong>, including Saturday, <strong>7.30am - 6pm</strong>.</p><p>Your items may arrive on different days and from different couriers.',
  // next or named delivery
  fulfilment_next_or_named_day_delivery_title: 'Next or named day delivery',
  fulfilment_next_or_named_day_delivery_description:
    'Your products may arrive separately or from different couriers',
  fulfilment_next_or_named_day_delivery_availability:
    'Arriving between <strong>7.30am - 6pm</strong>',
  fulfilment_arriving_between_7_30_6_00: 'Arriving between <strong>7.30am - 6pm</strong>',
  // next or named morning delivery
  fulfilment_next_or_named_morning_delivery_title: 'Next or named morning delivery',
  fulfilment_next_or_named_morning_delivery_description:
    'Your products may arrive separately or from different couriers',
  fulfilment_next_or_named_morning_delivery_availability:
    'Arriving on <strong>${date}<strong/> before <strong>10.30am</strong>',
  //
  fulfilment_to_be_delivered: 'Your items to be delivered',
  // -----------------------------------------------------------------------------------------------
  // Fulfilment Titles

  fulfilment_title_standard_5_days: 'Delivery within 5 working days',
  fulfilment_title_standard_2_days: 'Delivery within 2 working days',
  fulfilment_title_arriving_within_5_days_with_slot:
    'Arriving between <strong>7.30am - 6pm</strong>',
  fulfilment_title_products_may_arrive_separately: 'Your products may arrive separately',
  fulfilment_title_next_or_named_morning_delivery: 'Next or named morning delivery',
  fulfilment_title_arrival_date_before_10am_with_date: 'Arriving before <strong>10:30am</strong>',
  fulfilment_title_delivery_date_month: 'Delivery on ${dateStr}',
  fulfilment_title_seven_days_1: 'Delivery usually within 7 working days',
  // ---- Title 2
  fulfilment_title_your_delivery: 'Your delivery',
  fulfilment_title_standard_delivery: 'Standard delivery',
  fulfilment_title_four_hour_slot: '4 hour slot',
  fulfilment_title_two_hour_slot: '2 hour slot',
  fulfilment_title_express: 'Next day delivery',
  fulfilment_title_express_delivery: 'Express delivery',
  fulfilment_title_special_order: 'Stock coming soon',
  fulfilment_title_special_order_2: 'Standard specialist delivery',
  fulfilment_title_seven_days_2:
    "You'll be phoned within 2 working days of placing your order to arrange a delivery date",
  fulfilment_title_standard_unknown_2:
    'Your product will be delivered using our standard delivery method',
  fulfilment_title_approved_supplier: 'Delivery by our approved supplier',
  fulfilment_title_approved_supplier_2:
    'Where delivery needs to be arranged, you will be contacted to arrange a delivery date',
  // ---- Title 3
  fulfilment_title_arrival: 'UK Delivery usually within 7 working days',
  fulfilment_title_arrival_with_date: 'Arriving on <strong>${date}</strong>.',
  fulfilment_title_arrival_with_time: 'Arriving between <strong>${startTime} - ${endTime}</strong>',
  fulfilment_title_click_and_collect_availability:
    'Your order will be ready to collect at <strong>2pm</strong> on <strong>${date}</strong>',
  fulfilment_title_click_and_collect_description:
    "We'll hold your order in store for <strong>7 days</strong>, after which we'll return the order to the warehouse and refund your account",
  fulfilment_title_collect_plus_description:
    "Collect+ will send you an email and a text message when it's ready to collect",
  fulfilment_title_collect_plus_availability:
    'Your order will be ready to collect by the end of <strong>${date}</strong> and will be available for <strong>10 days</strong>',
  fulfilment_title_international_delivery: 'International delivery',
  fulfilment_approved_supplier_description: 'Delivered by our approved supplier',
  fulfilment_approved_supplier_availability_with_date: 'Arriving on <strong>${date}</strong>',
  fulfilment_approved_supplier_availability_with_date_and_time:
    'Arriving on <strong>${date}</strong> between <strong>${startTime} - ${endTime}</strong>',
  fulfilment_approved_supplier_availability_no_date:
    'Where delivery needs to be arranged, you will be contacted to arrange a delivery date',

  // 4 hour slot
  fulfilment_four_hour_slot_delivery_description: '4 hour slot',
  fulfilment_four_hour_slot_delivery_availability_with_date:
    'Arriving on <strong>${date}</strong>.',
  fulfilment_four_hour_slot_delivery_availability_with_date_and_time:
    'Arriving on <strong>${date}</strong> between <strong>${startTime} - ${endTime}</strong>.',
  fulfilment_four_hour_slot_delivery_availability_no_date:
    'Where delivery needs to be arranged, you will be contacted to arrange a delivery date',

  // 2 hour slot
  fulfilment_two_hour_slot_delivery_title: '2 hour slot',
  fulfilment_two_hour_slot_delivery_description: '2 hour slot',
  fulfilment_two_hour_slot_delivery_availability_with_date: 'Arriving on <strong>${date}</strong>.',
  fulfilment_two_hour_slot_delivery_availability_with_date_and_time:
    'Arriving on <strong>${date}</strong> between <strong>${startTime} - ${endTime}</strong>.',
  fulfilment_two_hour_slot_delivery_availability_no_date:
    'Where delivery needs to be arranged, you will be contacted to arrange a delivery date',

  // Express delivery
  fulfilment_express_delivery_title: 'Next Day Delivery',
  fulfilment_express_delivery_description: '2 hour slot',
  fulfilment_express_delivery_availability_with_date: 'Arriving on <strong>${date}</strong>.',
  fulfilment_express_delivery_availability_with_date_and_time:
    'Arriving on <strong>${date}</strong> between <strong>${startTime} - ${endTime}</strong>.',
  fulfilment_express_delivery_availability_no_date:
    'Where delivery needs to be arranged, you will be contacted to arrange a delivery date',

  // 7 days delivery
  fulfilment_uk_seven_days_delivery_title: 'Delivery usually within 7 working days',
  fulfilment_uk_seven_days_delivery_description:
    "You'll be phoned within <strong>2 working days</strong> of placing your order to arrange a convenient date for your delivery",
  fulfilment_uk_seven_days_delivery_availability_with_date: 'Arriving on <strong>${date}</strong>.',
  fulfilment_uk_seven_days_delivery_availability_with_date_and_time:
    'Arriving on <strong>${date}</strong> between <strong>${startTime} - ${endTime}</strong>.',
  fulfilment_uk_seven_days_delivery_availability_no_date:
    'Where delivery needs to be arranged, you will be contacted to arrange a delivery date',

  // Tradeplace
  fulfilment_tradeplace_description: 'Delivered by our approved supplier',
  fulfilment_tradeplace_availability_with_date: 'Arriving on <strong>${date}</strong>.',
  fulfilment_tradeplace_availability_with_date_and_time:
    'Arriving on <strong>${date}</strong> between <strong>${startTime} - ${endTime}</strong>.',
  fulfilment_tradeplace_availability_no_date:
    'Where delivery needs to be arranged, you will be contacted to arrange a delivery date',

  // Tracking actions
  tracking_action_for_delivery: 'Track delivery',
  tracking_action_for_package: 'Track package',

  // --------------------
  // View order
  // --------------------
  order_login_prompt:
    'You can manage your preferences and view your orders and VAT receipts simply by signing in.',
  // product table
  product_table_items_title: 'Your items',
  product_table_price_title: 'Price',
  product_table_subtotal_title: 'Subtotal',
  // backorder / out of stock items
  backorder_items_title: 'Out of stock items',
  backorder_items_info:
    "We're sorry but an item you ordered is out of stock – we'll deliver it when it's back in stock",
  // cancelled items
  cancelled_items_title: 'Cancelled items',
  cancelled_items_info:
    'Please note refunds will appear in your account within 5 working days. For more information see our <a target="_blank" href="https://www.johnlewis.com/customer-services/returns/our-refund-policy">refund policy</a>.',
  // return/refund items
  return_refund_items_info:
    'Please note refunds will appear in your account within 5 working days. For more information see our <a target="_blank" href="https://www.johnlewis.com/customer-services/returns/our-refund-policy">refund policy</a>.',
  return_raised_items_info:
    'Please return the following item(s) to us and if a refund is required we will issue it as soon as we receive them. For information about how to return your item(s) please see our <a target="_blank" href="https://www.johnlewis.com/customer-services/returns/how-do-i-return-an-item">returns policy</a>.',
  // order totals
  common_label_subotal: 'Subtotal',
  common_label_delivery_charge: 'Delivery charge',
  common_label_bundle_saving: 'Bundle saving',
  common_label_promotional_code: 'Promotional code',
  common_label_partner_discount: 'Partner discount',
  common_label_grand_total: 'Total',
  // calls to action
  print_order: 'Print order',
  print_receipt: 'Print receipt',
  // --------------------
  // track order form
  // --------------------
  track_my_order_form_title: 'Track my order',
  track_my_order_description:
    "If you don't have an account, enter your order number and billing postcode below.",
  track_order_form_title: 'Track your order',
  track_order_form_subtitle: 'View, track and manage all your orders',
  track_order_sign_in_info: 'Simply sign in if you have an account.',
  track_order_sign_in_cta: 'Sign in',
  track_order_form_info: 'Search for your order using your order number and postcode',
  formTrackMyOrderFormSubmit: 'Track order',

  // -------------
  // register form
  // -------------
  register_form_title: 'Create an account',
  formRegisterFormSubmit: 'Create account',
  registrationFailedMessage: 'Registration failed',

  already_have_account_title: 'Already have an account?',
  ctaSignIn: 'Sign in',

  // -------------
  // login form
  // -------------
  login_form_title: 'Sign in',
  formLoginFormSubmit: 'Sign in',

  dont_have_an_account: "Don't have an account?",
  create_an_account: 'Create an account',

  // ---------------
  // account created
  // ---------------
  accountCreatedTitle: 'Account created',
  accountCreatedMessage: 'Thank you for registering, you are now signed in.',
  ctaStartShopping: 'Start shopping',
  ctaContinueShopping: 'Continue shopping',

  joinMyJLTitle: 'Become a <span>my John Lewis</span> member',
  joinMyJLBody: 'Enjoy benefits like exclusive events, treats and rewards.',
  ctaJoinMyJL: 'Join my John Lewis',
  joinedMyJlHeading: 'Welcome',
  joinedMyJlText: "You're now a member of",
  joinedMyJlRewards: 'Exclusive Rewards',
  myJLTerms_legacy:
    'By joining my John Lewis you accept the <a href="https://www.johnlewis.com/customer-services/shopping-with-us/terms-and-conditions#cq-myjl">terms and conditions</a>.',
  myJLTerms:
    'By joining you accept the my John Lewis <a href="https://www.johnlewis.com/customer-services/shopping-with-us/terms-and-conditions?#cq-myjl">terms & conditions</a> and our <a target="_blank" rel="noopener noreferrer" href="https://www.johnlewis.com/customer-services/shopping-with-us/privacy-notice">privacy notice</a>.',

  houseNumberOrNameLabel: 'House number or name',
  houseNumberOrNameLabelRequired: 'Please enter a house number or name',

  // -----------------
  // privacy statement
  // -----------------
  privacy_statement_title: 'How we use your information',
  privacy_statement_info_legacy:
    'Treating your personal data with care is important to us. If you\'d like to know more see our <a target="_blank" rel="noopener noreferrer" href="https://www.johnlewis.com/customer-services/shopping-with-us/terms-and-conditions">privacy notice</a> where you can find detailed information on how we use your personal data, including how we personalise our communications to you.',
  privacy_statement_short_legacy:
    'Please find our <a target="_blank" rel="noopener noreferrer" href="https://www.johnlewis.com/customer-services/shopping-with-us/terms-and-conditions">privacy notice</a> here.',
  privacy_statement_info:
    'Treating your personal data with care is important to us. If you\'d like to know more see our <a target="_blank" rel="noopener noreferrer" href="https://www.johnlewis.com/customer-services/shopping-with-us/privacy-notice">privacy notice</a> where you can find detailed information on how we use your personal data, including how we personalise our communications to you.',
  privacy_statement_short:
    'We treat your personal data with care; please find our <a target="_blank" rel="noopener noreferrer" href="https://www.johnlewis.com/customer-services/shopping-with-us/privacy-notice">privacy notice</a> here.',

  // ---------------
  // help
  // ---------------
  helpIntro: 'Need help with your order? Find some useful links below.',

  // ---------------------
  // marketing preferences
  // ---------------------
  marketing_preferences_yes: 'Yes please',
  marketing_preferences_no: 'No thanks',
  marketing_preferences_submit: 'Save preferences',
  marketing_preferences_john_lewis:
    'Receive emails and texts containing tips, guidance, offers and news on new products and services.',
  marketing_preferences_waitrose:
    'Receive offers, news on latest products, local branch information and in-store events.',
  marketing_preferences_john_lewis_finance:
    'Receive offers on Partnership Card, Foreign Currency and information on other services.',
  marketing_preferences_my_john_lewis:
    'If you would like to stop receiving my John Lewis communications you have to cancel your membership on the my John Lewis page.',

  formLabelMyJohnLewisTermsAndConditionsLegacy:
    'I wish to join my John Lewis and receive communications',
  formLabelMyJohnLewisTermsAndConditions:
    'I agree to join my John Lewis and receive communications for exclusive rewards and benefits',
  formValidationMyJohnLewisTermsAndConditions: 'Please tick the box to proceed',
  myJohnLewisSubmit: 'Join',
  addAddressLineButtonLabel: 'Add address line',

  // ---------------------
  // Add Voucher
  // ---------------------
  giftVoucherSecurityCodeLabel: 'Security code',
  giftVoucherSerialNumberLabel: 'Serial number',
  allyDescriptionSecurityCode: 'Enter the 7-digit security code (scratch-off panel)',
  allyDescriptionSerialNumber: 'Enter the 10-digit serial number',
  formAddVoucherSubmit: 'Apply voucher',

  formLabelPartnerCardNumberLabel: 'Serial number',
  formValidationPartnerCardNumberRequired:
    'Please enter the 16-digit number on the bottom right of your Partnercard',

  formValidationGiftVoucherSecurityCodeRequired:
    'Please enter the 7 letter code under the scratch panel at the top left of your voucher',
  formValidationGiftVoucherSerialNumberRequired:
    'Please enter the 10-digit number on the bottom right of your voucher',

  voucherRedeemErrorMessage: 'Sorry, the voucher code you entered is not valid.',
  voucherRedeemErrorBody: 'Please try again.',
  voucherUnredeemErrorMessage: 'Sorry, an error occurred while redeeming your voucher.',
  voucherUnredeemErrorBody: 'Please call our contact centre on 03456 049 049 for assistance.',
};
